goog.provide("shadow.js.shim.module$$mui$material$TextField$default");
shadow.js.shim.module$$mui$material$TextField$default = shadow.js.shim.module$$mui$material$TextField.default;
